import React from 'react';
import { XIcon } from 'lucide-react';
import { InlineCta } from './InlineCta';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
import { pains, shortQuote } from '../data/offer';
export function Pains() {
  return <section className="border-t border-espresso-line bg-espresso-2 px-5 py-14" data-id="element-219" data-mp="r958o9rhbgld">
      <SectionHeading dark eyebrow="Ti suona familiare?" title="Insegnare il flauto" accent="non dovrebbe sfinirti" sub="Se ti riconosci in una di queste situazioni, questo pack è stato creato per te." data-id="element-220" data-mp="v8485eufyl5f" />
      <ul className="mt-9 space-y-3" data-id="element-221" data-mp="7jbe5nxdqndg">
        {pains.map((pain, i) => <Reveal key={pain} delay={i * 0.04} data-id="element-222" data-mp="7le9mnhax8pk" data-mpi={i}>
            <li className="flex gap-3.5 rounded-2xl border border-espresso-line bg-espresso p-4" data-id="element-223" data-mp="cj7end6vbwo9">
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-alert/40 bg-alert/10" data-id="element-224" data-mp="1ix6rqs8myo2k">
                <XIcon className="h-3.5 w-3.5 text-[#FF8A8D]" strokeWidth={3} aria-hidden="true" data-id="element-225" data-mp="1nvgov8dx7yqt" />
              </span>
              <p className="text-[15px] leading-relaxed text-ivory" data-id="element-226" data-mp="1bjjcdlomcuj5">{pain}</p>
            </li>
          </Reveal>)}
      </ul>
      <Reveal className="mt-10 border-l-2 border-wood pl-5" data-id="element-227" data-mp="11mwt31bxybj8">
        <figure data-id="element-228" data-mp="11pizgxn3ikzv">
          <blockquote className="font-serif text-xl italic leading-snug text-ivory" data-id="element-229" data-mp="wova0geimc7r">“{shortQuote.text}”</blockquote>
          <figcaption className="mt-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-wood" data-id="element-230" data-mp="snje5t51sur4">
            — {shortQuote.author}
          </figcaption>
        </figure>
      </Reveal>
      <InlineCta dark label="Basta improvvisare" data-id="element-231" data-mp="iwoumwj6s99d" />
    </section>;
}